import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  public static readonly CLIENT_VERSION = "clientVersion"

  public static readonly TOKEN = "token";
  public static readonly CURRENT_USER = "currentUser";

  public static readonly LEAD_ID = 'leadId'
  public static readonly REF = 'ref'

  public static readonly REGION_SLUG = "regionSlug";
  public static readonly COUNTRY_SLUG = "countrySlug"
  public static readonly PRODUCT_SLUG = "productSlug";
  public static readonly PROMOTION_CODE = "promotionCode";
  public static readonly PLACE_SLUG = "placeSlug";
  public static readonly COMPANY_SLUG = "companySlug";

  public static readonly CONVERSATION_TYPE = "conversationType";
  public static readonly CONVERSATION_SLUG = "conversationSlug";

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  }

  get(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      console.debug(`[StorageService] get ${key}`)

      // Removing null values from storage
      const item = localStorage.getItem(key)
      if (item === null || item === "null") {
        this.remove(key);
        return null;
      }

      return localStorage.getItem(key);
    }

    return null;
  }

  add(key: string, value: any) {
    if (isPlatformBrowser(this.platformId)) {
      console.debug(`[StorageService] add ${key} - ${value}`)

      // Removing null values from storage
      if (value === null || value === "null") {
        this.remove(key)
        return;
      }

      localStorage.setItem(key, value);
    }
  }

  remove(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      console.debug(`[StorageService] remove ${key}`)
      localStorage.removeItem(key);
    }
  }

  clear() {
    if (isPlatformBrowser(this.platformId)) {
      console.debug(`[StorageService] clear`)
      localStorage.clear()
    }
  }

}
